export default __webpack_public_path__ + "static/media/pictogramBeaconProcess48.55f23233.svg";